import debounce from "lodash.debounce";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { fetchGet, toQueryString } from "../../../../service/api_client";
import {
  ToastType,
  useToast,
} from "../../../../context_providers/toast/toast_ctx";
import POAutoCompleteField from "../../../purchase_order/purchase_order_create/components/po_auto_complete_widget";
import { WarehouseModel } from "../../models/warehouse_model";

interface WarehouseSearchFieldProps {
  onSelect: (data: WarehouseModel) => void;
  disabled?: boolean;
  placeholder?: string;
  value?: WarehouseModel;
  type?: string;
}

const WarehouseSearchField: FunctionComponent<WarehouseSearchFieldProps> = (
  props,
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/warehouse_type`;
  const { showToast } = useToast();
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [addNew, setAddNew] = useState(false);
  const [data, setData] = useState<WarehouseModel[]>();
  const getData = async (prop: {
    type?: string;
    search?: string;
    page: number;
    count: number;
    all?: boolean;
  }) => {
    setLoading(true);
    try {
      const res = await fetchGet(url + toQueryString(prop));
      if (res.success) {
        setData(res.data.data);
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };

  const debouncedHandler = useCallback(
    debounce((query) => {
      if (query)
        getData({
          search: query,
          page: 1,
          count: 1,
          all: true,
          type: props?.type,
        });
      else setData(undefined);
    }, 500),
    [],
  );

  useEffect(() => {
    if (search && edit) {
      if (props.value && props.value.name === search) return;
      debouncedHandler(search);
    }
  }, [search]);
  useEffect(() => {
    setSearch(props.value?.name ?? "");
  }, [props.value]);
  return (
    <div className="flex gap-1 items-center    w-full">
      {edit ? (
        <POAutoCompleteField
          onAddNew={() => {
            setAddNew(true);
          }}
          loading={loading}
          value={search}
          placeholder={props.placeholder ?? "Search"}
          onSelect={(val) => {
            setEdit(false);
            setSearch(val.value.name);
            props.onSelect(val.value);
          }}
          suggestions={data?.map((d) => ({
            label: (
              <div className="text-xs">
                <b> {d.name} </b>
              </div>
            ),

            value: d,
          }))}
          onChange={setSearch}
        />
      ) : (
        // <div
        //   title={search}
        //   className={`text-sm px-3 py-2  h-8 rounded focus:outline-none w-full border overflow-hidden overflow-ellipsis ${
        //     search ? "" : " text-gray-400 "
        //   }`}
        //   onClick={() => {
        //     if (!props.disabled) {
        //       setEdit(true);
        //       // setSearch(emp?.name ?? "");
        //     }
        //   }}
        // >
        //   {search || props.placeholder || "Search"}
        // </div>
        <div
          title={search}
          className={`text-sm px-4 py-3 h-12 rounded focus:outline-none w-full border ${
            search ? "overflow-x-auto whitespace-nowrap" : "text-gray-400"
          }`}
          style={{
            maxWidth: "100%",
            overflowY: "hidden",
            overflowX: "auto",
          }}
          onClick={() => {
            if (!props.disabled) {
              setEdit(true);
            }
          }}
        >
          {search || props.placeholder || "Select warehouse "}
        </div>
      )}
      {/* {addNew && (
        <ModalDialog
          onClose={() => {
            setAddNew(false);
          }}
          show={addNew}
          title={"Add Item"}
        >
          <div
            className="overflow-auto"
            style={{ maxHeight: "80vh", maxWidth: "80vw " }}
          >
            <InventoryBasketCreateScreen
              onClose={(d) => {
                if (d) {
                  setEdit(false);
                  setSearch(d.name);
                  props.onSelect(d);
                  setAddNew(false);
                }
              } } edit={false}            />
          </div>
        </ModalDialog>
      )} */}
    </div>
  );
};

export default WarehouseSearchField;
